import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { createPortal } from 'react-dom';
const modalRoot = document.querySelector('#root-modal');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

export const Modal = ({ children }) => createPortal(children, modalRoot);
